<script>
import formatDate from "@utils/format-date"
import { default as messagePlugin, messageSuccess } from "@utils/message"
import { authComputed, merchantComputed } from "@store/helpers"
import { replaceWindowHistory } from "@utils/window-history"

export default {
  computed: {
    ...authComputed,
    ...merchantComputed,
    lineNotifyUrl() {
      const lineAPI = 'https://notify-bot.line.me/oauth/authorize'
      const clientId = this.currentMerchant.lineNotifyClientId
      const merchantAlias = this.currentMerchant.alias
      const redirectUri = window.location.protocol + '//' + window.location.hostname.replace(`${merchantAlias}.`, '') + '/line-notify'
      const bindUrl = `${window.location.origin}/line-notify-bind`
      const query = `response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=notify&state=${bindUrl}`
      return `${lineAPI}?${query}`
    },
    isBound() {
      return this.currentMember?.lineInfo.isBindLineNotify
    }
  },
  mounted() {
    if (this.$route.query.scrollToId) {
      this.scrollToId(this.$route.query.scrollToId)
      replaceWindowHistory({
        query: {
          scrollToId: undefined,
        }
      })
    }

    const showLineNotifyBindResult = () => {
      const {message, messageType} = this.$route.query
      if (message !== undefined && messageType !== undefined) {
        messagePlugin({
          message,
          type: messageType,
          duration: 2000,
        })
      }
      replaceWindowHistory({
        query: {
          message: undefined,
          messageType: undefined,
        }
      })
    }

    showLineNotifyBindResult()
  },
  methods: {
    formatDate,
    async tryToUnbindLineNotify() {
      await this.$store.dispatch('auth/lineNotifyUnbind')
      messageSuccess('成功解除綁定')
      this.tryToFetchMemberInfo()
    },
    tryToFetchMemberInfo() {
      this.$store.dispatch('auth/fetchMember')
    },
    scrollToId(id) {
      this.$scrollToElement({
        $el: document.getElementById(id),
        offset: 100,
      });
    },
  }
}
</script>
<!-- section template -->
<template>
  <div id="line-notify" class="mb-5 pt-4">
    <div class="layout__header">
      <h2 class="layout__title align-items-center d-flex">
        LINE Notify
        <img class="ml-3" src="https://scdn.line-apps.com/n/line_notice/img/icon/favicon_160829.ico" style="width: 1.875rem;border-radius: 20px;"/>
      </h2>
    </div>
    <div class="mb-1">
      <i class="fontello fontello-attention text-danger mr-2"></i>
      <span v-if="!isBound">綁定成功後，簡訊通知將改由 LINE Notify 來發送，您將不會再收到簡訊通知。</span>
      <span v-else>若您想改回簡訊通知請按下「解除」按鈕。</span>
    </div>
    <div class="mb-3">
      <i class="fontello fontello-attention text-danger mr-2"></i>
      <span>提醒您，若綁定line notify後再登入網站，簡訊驗證碼將會改傳到line notify上。</span>
    </div>
    <div :class="$style.lineNotify">
      <div v-if="isBound">
        <div class="lineNotify__date">{{ formatDate(currentMember.lineInfo.lineNotifyBindAt, 'yyyy.MM.dd HH:mm') }}</div>
        <div class="lineNotify__title">{{ currentMember.lineInfo.lineNotifyName }}</div>
      </div>
      <div v-else class="lineNotify__empty mr-3">
        <el-tag type="danger" effect="plain">尚未綁定</el-tag><br>
        <small>綁定時請選擇「透過1對1聊天接收LINE Notify的通知」<br>然後點擊下方「同意並連動」。</small>
      </div>
      <div class="d-flex align-items-center">
        <BaseButton
          v-if="!isBound"
          class="isStyleSecondary  isSmall mr-3 flex-fill flex-sm-grow-0"
          :class="{ isFillet: !$globalIsDingBeauty }"
          :href="lineNotifyUrl"
          target="_self"
        >
          綁定 LINE Notify
        </BaseButton>
        <BaseButton
          v-else
          :loading="$isLoading('lineNotifyUnbind')"
          class="isStyleDark isOutline3 isFillet isSmall flex-fill flex-sm-grow-0"
          @click="tryToUnbindLineNotify"
        >
          解除
        </BaseButton>
      </div>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.lineNotify {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid $color-line;
  padding: 40px;

  @include max-sm {
    flex-direction: column;
    align-items: inherit;
    .baseButton {
      width: 100%;
      & + .baseButton {
        margin-top: 3rem;
      }
    }
  }

  :global {
    .lineNotify {
      &__date {
        font-family: $font-number;
        color: $color-gray-3;
      }

      &__title {
        font-size: 1.1rem;
        font-weight: 600;
        color: $color-gray-1;

        @include max-sm {
          margin-bottom: 3rem;
        }
      }

      &__empty {
        font-size: 1.2rem;
        color: $color-gray-3;
      }      
    }
  }
}
</style>
